import cn from "./cn";

const message = {
  cn,
};

export default { message };
